import { mapState, mapGetters, mapMutations } from 'vuex';
import deepClone from 'lodash.clonedeep';
import router from '@/router';

export default {
  data: () => {
    return {
      formModel: {},
      tabHash: '',
    };
  },

  computed: {
    ...mapState('admin', [
      'formChanged',
    ]),

    ...mapGetters([
      'buildSchema',
    ]),

    formOptions() {
      return Object.assign({ context: this }, this.$store.state.formOptions);
    },
  },

  methods: {
    ...mapMutations('admin', [
      'setFormChanged',
    ]),

    editForm(data, form, options = {}) {
      this.$store.dispatch(`admin/edit${this.formName}`, { data, form }).then(() => {
        if (!options.noRedirect) {
          const route = { name: this.formIndex };
          if (this.formParentQuery) {
            route.query = {};
            route.query[this.formParentQuery.key] = this.formParentQuery.value;
          }
          router.push(route);
        }
      }).catch(() => {
        if (options.tabHash) {
          window.location.hash = options.tabHash;
        }
      });
    },

    defineFormObjects() {
      this.formModel = deepClone(this[`active${this.formName}`]);
    },

    handleTabChange(event) {
      if (!this.tabHash) {
        this.tabHash = event.tab.hash;
      }
      const form = event.tab.$children[0];
      // eslint-disable-next-line no-alert
      if (this.formChanged && confirm('You have unsaved changes. Would you like to save these?')) {
        this.editForm(this.formModel, form, { noRedirect: true, tabHash: this.tabHash });
      }
      this.setFormChanged(false);
      this.tabHash = event.tab.hash;
    },
  },

  created() {
    this.setFormChanged(false);
    this.defineFormObjects();
  },

  beforeRouteUpdate(to, from, next) {
    this.$store.commit(`admin/setActive${this.formName}`, parseInt(to.params[`${this.formName.toLowerCase()}Id`]));
    next();
  },
};
